import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";

export function defaultTranslation(TemplateComponent: any) {
	return withTranslation()(TemplateComponent);
}

export function defaultTemplate(TemplateComponent: any) {
	return defaultTranslation(observer(TemplateComponent));
}
